import { Component, Vue } from 'nuxt-property-decorator';
import { Descriptions } from '~/types/catalog';

@Component
export default class NewsPageComponent extends Vue {

    public text: string = null;
    public meta: Descriptions = null;

    public head() {
        return {
            title: this.meta.title,
            meta: [
                { vmid: 'description', name: 'description', content: this.meta.description }
            ]
        };
    }

    public async asyncData({ store, params }) {

        const code = params.code;

        const data =  await store.dispatch('data/FetchTextPage', {
            code,
            type: 'news',
        });

        store.commit('setBreadcrumbs', [
            {name: 'Новости', link: '/news/'},
            {name: data.meta.h1},
        ]);

        return data;

    }
}
